import { render, staticRenderFns } from "./AdminBuild.vue?vue&type=template&id=21b924e8"
import script from "./AdminBuild.vue?vue&type=script&lang=js"
export * from "./AdminBuild.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports